export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/node_modules/fela/es/isSafeClassName.js
// module id = 738
// module chunks = 0